import React from 'react';
import RefundDeadlineBadge from './RefundDeadlineBadge';
import { formatDisplayDate, buildClosedRefundMessage } from '../../utils/refundTimeline';
const detailItem = (label, value) => (
  <div>
    <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginBottom: '4px' }}>{label}</div>
    <div style={{ fontSize: '14px', fontWeight: 600, color: 'var(--text)' }}>{value || '—'}</div>
  </div>
);

const formatFeedbackLabel = (value) =>
  value
    ? value
        .toString()
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase())
    : '—';

const OrderFormDetailsPanel = ({ order, product }) => {
  if (!order) return null;

  const timeline = order.refundTimeline;
  const orderFormFilledOn =
    order.orderFormFilledAt ||
    (timeline?.daysSinceOrderFormFilled != null
      ? `${timeline.daysSinceOrderFormFilled} day(s) ago`
      : null);

  return (
    <div
      style={{
        background: 'var(--bg-deep)',
        padding: '16px',
        borderRadius: '10px',
        border: '1px solid var(--border)',
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
      }}
    >
      <div>
        <h3 style={{ margin: '0 0 4px 0', fontSize: '16px', fontWeight: 700, color: 'var(--text)' }}>
          Order form details
        </h3>
        <p style={{ margin: 0, fontSize: '13px', color: 'var(--text-muted)' }}>
          These details were submitted when the order form was filled.
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '14px',
        }}
      >
        {detailItem('Order ID', order.orderId)}
        {detailItem('Order form filled', formatDisplayDate(order.orderFormFilledAt) || orderFormFilledOn)}
        {detailItem('Platform order date', formatDisplayDate(order.orderDate))}
        {detailItem('Product', order.productName || product?.productName || order.productId)}
        {detailItem('Product code', product?.productCode)}
        {detailItem('Reviewer name', order.reviewerName)}
        {detailItem('Mediator', order.mediatorName)}
        {detailItem('Feedback type', formatFeedbackLabel(order.dealFeedbackType))}
        {detailItem('Order amount', order.orderAmount != null ? `₹${order.orderAmount}` : '—')}
        {detailItem('WhatsApp', order.whatsappNumber ? `+91 ${order.whatsappNumber}` : '—')}
        {detailItem('Email', order.userEmail)}
      </div>

      {timeline && (
        <div
          style={{
            padding: '12px',
            borderRadius: '8px',
            background: '#ffffff',
            border: '1px solid var(--border)',
          }}
        >
          <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--text)', marginBottom: '8px' }}>
            Refund timeline
          </div>
          <RefundDeadlineBadge timeline={timeline} large />
          {timeline.refundDeadlineDate && (
            <p style={{ margin: '8px 0 0', fontSize: '12px', color: 'var(--text-muted)' }}>
              Refund form closes on: <strong>{formatDisplayDate(timeline.refundDeadlineDate)}</strong>
              {timeline.daysLeftToClose != null && ` (${timeline.daysLeftToClose} day(s) left)`}
            </p>
          )}
          {timeline.daysSinceOrderFormFilled != null && (
            <p style={{ margin: '6px 0 0', fontSize: '12px', color: 'var(--text-muted)' }}>
              {timeline.daysSinceOrderFormFilled} day(s) since order form was filled.
            </p>
          )}
          {(timeline.warningLevel === 'PENALTY_50' ||
            timeline.warningLevel === 'PENALTY_100' ||
            (timeline.penaltyAmount != null && Number(timeline.penaltyAmount) > 0)) && (
            <div
              style={{
                marginTop: '10px',
                padding: '10px 12px',
                borderRadius: '8px',
                background: '#fef2f2',
                border: '1px solid #fecaca',
                color: '#991b1b',
                fontSize: '13px',
                fontWeight: 600,
              }}
            >
              {timeline.warningMessage ||
                `Late refund: ₹${timeline.penaltyAmount} penalty will apply.`}
            </div>
          )}
          {!timeline.refundFormOpen && (
            <div
              style={{
                marginTop: '10px',
                padding: '10px 12px',
                borderRadius: '8px',
                background: '#f3f4f6',
                border: '1px solid #d1d5db',
                color: '#374151',
                fontSize: '13px',
                fontWeight: 600,
              }}
            >
              {buildClosedRefundMessage(timeline.policy)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OrderFormDetailsPanel;
